import {Component, Inject, OnInit, PLATFORM_ID, ViewContainerRef} from '@angular/core'
import {LinkService} from './core/i18n/link.service'
import {FaviconService} from './core/favicon/favicon.service'
import {LoadingProgressService} from './core/components/loading/loading-progress.service'
import {isPlatformBrowser} from '@angular/common'
import {QueryParamsService} from './core/query-params/query-params.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(
    @Inject(LinkService) public readonly linkService: LinkService,
    private readonly faviconService: FaviconService,
    private readonly loadingProgressService: LoadingProgressService,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly queryParamsService: QueryParamsService,
    @Inject(PLATFORM_ID) private platformId,
  ) {
    this.faviconService.createFavicons('assets/favicon.ico', 'assets/favicon-neg.ico')
  }

  ngOnInit(): void {
    this.loadingProgressService.showOnRouteChange(this.viewContainerRef)
    this.linkService.saveReferrer()

    if (isPlatformBrowser(this.platformId)) {
      const referrerUrl = document?.referrer ? new URL(document.referrer) : undefined
      const currentUrl = new URL(window.location.href)

      this.queryParamsService.applyQueryParams(currentUrl, referrerUrl)
    }
  }
}
